<div class="dhl-header-image">
  <div class="dhl-container">
    <div class="row">
      <div class="col">
        <h1 color="white">Cotice sus guías prepagadas</h1>
      </div>
    </div>
    <div class="row mt-3">
      <!-- Seccion para guias individuales -->
      <div class="col fs-5">
        <h5 color="white">
          Calcule el costo de sus guías de manera individual, o elija <br />
          uno de nuestros paquetes en la siguiente sección.
        </h5>
      </div>
      <!-- <div class="col">
        <h3 color="white">Elija uno de nuestros paquetes en la siguiente sección</h3>
      </div> -->
    </div>
    <!-- Seccion para guias individuales -->
    <div class="row mt-3">
      <div class="col-sm-5 col-md-3">
        <h2 color="white">Cantidad de guías</h2>
        <input type="text" class="input-value-t-cart" placeholder="valorParaFomrulario" value="10" id="quantityguinnn" #inputGuideIndividual />
        <dhl-counter-less-add-home
          id="{{'quantityguinnn'}}"
          [nombre]="'quantityguinnn'"
          [identificador]="'counter-individual-guides-counter'"
          [minValue]="10"
          [maxValue]="15000"
          [valueEntry]="'10'"
          (executeMethodForPathern)="callServiceIndividualGuidesOriginEvent($event)"></dhl-counter-less-add-home>
      </div>
      <div class="col-sm-12 col-md-9 mt-2">
        <h2 color="white">Total a pagar</h2>
        <h2 color="white">{{ individualGuide.totalToPay | currency }} MXN</h2>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <button
          (click)="addToCart('guide', null, 'titlepackguide', 'counter-individual-guides-counter')"
          id="titlepackguide"
          mat-flat-button
          color="accent"
          [disabled]="addToCartDisable">
          Agregar al carrito
        </button>
      </div>
    </div>
  </div>
</div>
<div class="dhl-container">
  <div class="row">
    <div class="col-12 w-100 title-marign">
      <div class="row">
        <div class="col">
          <h2 color="black">Ahorra con nuestros paquetes de guí­as</h2>
        </div>
      </div>
    </div>
    <div class="row pb-2 pt-2 target" *ngFor="let package of guidePacks">
      <div class="col-sm-12 col-md-3 text-center">
        <div class="row d-flex position-relative">
          <div class="col me-2">
            <img src="./assets/images/home/packages@2x.png" alt="..." class="dhl-package-image" />
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-4">
        <div class="row">
          <div class="col">
            <h3 class="mt-3">{{ package.name }}</h3>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>{{ package.description }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <small class="reset-styles quinatity-paq">Cantidad de paquetes</small>
            <input type="text" class="input-value-t-cart" placeholder="valorParaFomrulario" value="1" id="{{getInputId(package)}}" />
            <dhl-counter-less-add
              [maxValue]="20"
              [valueEntry]="'1'"
              [nombre]="getInputId(package)"
              [identificador]="package.idGuidePackage"
              id="{{getInputId(package)}}"></dhl-counter-less-add>
          </div>
        </div>
        <div class="row">
          <div class="col d-flex mt-10 justify-content-lg-start"></div>
        </div>
      </div>
      <div class="col-sm-12 col-md-5 text-center mt-3">
        <div class="row">
          <div class="col">
            <span class="dhl-badge">Descuento {{ package.discount | currency }} MXN</span>
            <span class="span-before">Antes {{ package.subtotal | currency }} MXN</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h3 class="price-end">{{ package.totalToPay | currency }} MXN</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <button
              mat-flat-button
              (click)="addToCart('packages', package, getInputId(package) + 'c', package.idGuidePackage)"
              id="{{getInputId(package) + 'c'}}"
              color="accent"
              [disabled]="false">
              Agregar al carrito
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
